import { render, staticRenderFns } from "./EmailConfirmationPage.vue?vue&type=template&id=610ccb38&scoped=true&"
import script from "./EmailConfirmationPage.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmationPage.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmationPage.vue?vue&type=style&index=0&id=610ccb38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ccb38",
  null
  
)

export default component.exports